import { getArtikelGemerkt, removeArtikelGemerkt, setArtikelGemerkt } from "./ApiCalls.js";

document.addEventListener('DOMContentLoaded', markInhalteGemerkt);
document.addEventListener('htmx:afterSettle', markInhalteGemerkt);

const artikeldetail = document.querySelector(`[id^="artikel_detail_"]`);
const downloaddetail = document.querySelector(`[id^="download_detail_"]`);

const favoriteButtons = document.querySelectorAll("#article_favorite");

let inhalt = null;

if (artikeldetail !== null) {
  inhalt = artikeldetail;
} else if (downloaddetail !== null) {
  inhalt = downloaddetail;
}

function markInhalteGemerkt() {
  if (inhalt !== null) {
    const parts = inhalt.id.split('_');
    const inhalt_id = parts[parts.length - 1];

    if (inhalt_id !== undefined && favoriteButtons.length > 0) {
      getArtikelGemerkt(inhalt_id).then(res => {
        if (res === null || res === false) { return; }

        favoriteButtons.forEach(favoriteButton => {
          favoriteButton.classList.replace("text-neutral-subtle", "text-primary-on-surface");
          favoriteButton.classList.replace("before:content-bookmark-outline", "before:content-bookmark-filled");
          favoriteButton.firstElementChild.innerHTML = "Favorit entfernen";
          favoriteButton.dataset.aktiviert = true;
        });
      });
    }
  }
}

if (inhalt !== null && favoriteButtons.length > 0) {
  favoriteButtons.forEach(favoriteButton => {
    favoriteButton.addEventListener("click", (event) => {

      const parts = inhalt.id.split('_');
      const inhalt_id = parts[parts.length - 1];

      if (inhalt_id == undefined) {
        return;
      }

      if (favoriteButton.dataset.aktiviert == "false" || typeof favoriteButton.dataset.aktiviert == "undefined") {
        setArtikelGemerkt(inhalt_id).then(res => {
          if (res === null) { return; }
          favoriteButtons.forEach(favoriteButton => {
            favoriteButton.classList.replace("text-neutral-subtle", "text-primary-on-surface");
            favoriteButton.classList.replace("before:content-bookmark-outline", "before:content-bookmark-filled");
            favoriteButton.firstElementChild.innerHTML = "Favorit entfernen";
            favoriteButton.dataset.aktiviert = true;
          });
        });
      } else {
        removeArtikelGemerkt(inhalt_id).then(res => {
          if (res === null) { return; }
          favoriteButtons.forEach(favoriteButton => {
            favoriteButton.classList.replace("text-primary-on-surface", "text-neutral-subtle");
            favoriteButton.classList.replace("before:content-bookmark-filled", "before:content-bookmark-outline");
            favoriteButton.firstElementChild.innerHTML = "Favorit hinzufügen";
            favoriteButton.dataset.aktiviert = false;
          });
        });
      }
    });
  });
}